var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "container" }, [
    _c(
      "div",
      {
        staticClass: "mt-6 mb-5 d-flex align-center",
        attrs: {
          "data-qa": "breadcrumbs_page",
          itemtype: "https://schema.org/BreadcrumbList",
        },
      },
      _vm._l(_vm.items, function ({ name, href }, index) {
        return _c(
          "div",
          {
            key: name,
            staticClass: "d-flex align-center",
            attrs: {
              itemprop: "itemListElement",
              itemscope: "",
              itemtype: "https://schema.org/ListItem",
            },
          },
          [
            _c(
              "a",
              {
                staticClass:
                  "text-secondary--text text-body-1 link-decoration-none",
                attrs: {
                  itemprop: "item",
                  "data-qa": "breadcrumbs_item",
                  href: href,
                },
              },
              [
                _c("span", { attrs: { itemprop: "name" } }, [
                  _vm._v("\n          " + _vm._s(name) + "\n        "),
                ]),
                _vm._v(" "),
                _c("meta", {
                  attrs: { itemprop: "position", content: String(index + 1) },
                }),
              ]
            ),
            _vm._v(" "),
            _vm.items.length - 1 !== index
              ? _c(
                  "div",
                  { staticClass: "text-secondary--text text-body-1 px-2" },
                  [_vm._v("\n        »\n      ")]
                )
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }